/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Edit_Notes_PlaceholderInputs */

const en_samples_edit_notes_placeholder = /** @type {(inputs: Samples_Edit_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal notes or rejection reason...`)
};

const es_samples_edit_notes_placeholder = /** @type {(inputs: Samples_Edit_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas internas o razon de rechazo...`)
};

/**
* | output |
* | --- |
* | "Internal notes or rejection reason..." |
*
* @param {Samples_Edit_Notes_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_edit_notes_placeholder = /** @type {((inputs?: Samples_Edit_Notes_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Edit_Notes_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_edit_notes_placeholder(inputs)
	return es_samples_edit_notes_placeholder(inputs)
});